// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__9Qjzn","label":"CategoryService_label__durJ6","location":"CategoryService_location__aggl_"};